module.exports = __webpack_public_path__ + "fonts/ARIClean-Light.ef5a4913.otf";